<template>
  <nav class="navbar">
    <NavbarUser />
  </nav>
</template>

<script>
import NavbarUser from './NavbarUser.vue'

export default {
  name: 'Navbar',
  components: {
    NavbarUser,
  },
}

</script>

<style lang="scss" scoped>
@import "@/scss/colors.scss";

.versao {
  color: $cor-fonte-clara;
  margin: 0.5em;
}

.navbar {
  z-index: 100;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
  width: 100%;
  min-height: 3rem;
  background-color: $cor-principal-escura;
}

</style>
